import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Margin } from 'styled-components-spacing';

import Checkmarks from 'routes/_components/layout/components/footer/components/checkmarks/Checkmarks';
// import RecommendedHotels from 'components/recommendedHotels/RecommendedHotels';
import ThemeBox from './components/ThemeBox';

import { mediaQueries } from 'styles/utils/mediaQueries';

import loadableVisibility from 'react-loadable-visibility/loadable-components';
import InfiniteThreeDots from 'components/spinners/InfiniteThreeDots';

const RecommendedHotels = loadableVisibility(() => import('components/recommendedHotels/RecommendedHotels'), {
  fallback: <InfiniteThreeDots />,
});

const propTypes = {
  title: PropTypes.string.isRequired,
  themes: PropTypes.array.isRequired,
  packages: PropTypes.object.isRequired,
};

function ThemesListTemplateComponent({ title, themes, packages, airlineWhitelabel }) {
  return (
    <Fragment>
      <Background />
      <Root>
        <Title>{title}</Title>
        <ThemesWrap>
          {themes.map((theme) => (
            <ThemeBox key={theme.id} {...theme} packages={packages[theme.id]} airlineWhitelabel={airlineWhitelabel} />
          ))}
        </ThemesWrap>
      </Root>
      <Margin top='3' />
      <RecommendedHotels />
      <Checkmarks hideHighlights />
    </Fragment>
  );
}

ThemesListTemplateComponent.propTypes = propTypes;

export default ThemesListTemplateComponent;

const Background = styled.div`
  position: absolute;
  z-index: -1;
  margin-top: 200px;
  width: 100vw;
  height: 100%;
  background: ${({ theme }) =>
    theme.colors.footer.waves ? theme.colors.footer.waves : 'linear-gradient(to bottom, #fff9f2, #ffffff)'};
`;

const Root = styled.div`
  width: 1024px;
  margin: 0 auto;
  padding: 0 15px;

  ${mediaQueries.fromAndBelow.desktop`
    width: 768px;
  `}

  ${mediaQueries.fromAndBelow.tablet`
    width: 100%;
  `}
`;

const Title = styled.h1`
  width: 100%;
  margin-top: 130px;
  margin-bottom: 100px;
  font-size: 72px;
  font-weight: bold;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.templates.header};
`;

const ThemesWrap = styled.div``;
